import { render, staticRenderFns } from "./SendMessagePreview.vue?vue&type=template&id=329f7023&scoped=true&lang=pug"
import script from "./SendMessagePreview.vue?vue&type=script&lang=ts"
export * from "./SendMessagePreview.vue?vue&type=script&lang=ts"
import style0 from "./SendMessagePreview.vue?vue&type=style&index=0&id=329f7023&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "329f7023",
  null
  
)

export default component.exports